/* global YT */
import $ from 'jquery'
import MicroModal from 'micromodal'
import vimeo_player from '@vimeo/player'

let player

/**
 * @link https://developers.google.com/youtube/iframe_api_reference
 */
const tag = document.createElement('script')
tag.src = 'https://www.youtube.com/iframe_api'
const firstScriptTag = document.getElementsByTagName('script')[0]
firstScriptTag.parentNode.insertBefore(tag, firstScriptTag)

function onYouTubeIframeAPIReady() {
	player = new YT.Player('youtube_player_embed_js', {
		playerVars: {
			playsinline: 1,
		},
	})

	$('#property_video_js').on('click', function (event) {
		event.preventDefault()

		const video_host = $(this).data('video-host')

		if ('youtu.be' === video_host || 'youtube.com' === video_host || 'www.youtube.com' === video_host) {
			// Is Youtube.
			MicroModal.show('modal-video', {
				onShow: () => {
					player.playVideo ? player.playVideo() : 'no player'
				},
				onClose: (modal, element, event) => {
					player.pauseVideo ? player.pauseVideo() : ''

					if (event) {
						event.preventDefault()
						event.stopPropagation()
					}
				},
				disableScroll: true,
			})
		} else if ('player.vimeo.com' === video_host) {
			// Is Vimeo.
			MicroModal.show('modal-video', {
				onShow: () => {
					const iframe = document.getElementById('vimeo_player_embed_js')
					const player = new vimeo_player(iframe)
					player.play()
				},
				onClose: (modal, element, event) => {
					const iframe = document.getElementById('vimeo_player_embed_js')
					const player = new vimeo_player(iframe)
					player.pause()

					if (event) {
						event.preventDefault()
						event.stopPropagation()
					}
				},
				disableScroll: true,
			})
		} else {
			// Is anything else.
			MicroModal.show('modal-video')
		}
	})
}

// eslint-disable-next-line
window.onYouTubeIframeAPIReady = onYouTubeIframeAPIReady
